export enum rbacActions {

    GetDashboard = 'GetDashboard',

    GetUserAccount = 'GetUserAccount',
    UpdateUserAccount = 'UpdateUserAccount',
    DeleteUserAccount = 'DeleteUserAccount',

    ListAccountApplications = 'ListAccountApplications',
    GetAccountApplication = 'GetAccountApplication',
    CreateAccountApplication = 'CreateAccountApplication',
    UpdateAccountApplication = 'UpdateAccountApplication',
    DeleteAccountApplication = 'DeleteAccountApplication',

    ListApplications = 'ListApplications',
    GetApplication = 'GetApplication',
    CreateApplication = 'CreateApplication',
    UpdateApplication = 'UpdateApplication',
    DeleteApplication = 'DeleteApplication',

    ListSubscriptions = 'ListSubscriptions',
    GetSubscription = 'GetSubscription',
    CreateSubscription = 'CreateSubscription',
    UpdateSubscription = 'UpdateSubscription',
    DeleteSubscription = 'DeleteSubscription',

    // FNP-892: ListTenantApplications REMOVED. It was never in the Verified
    // Permissions schema (get-schema returns 26 actions for FlexiNetPortal, none
    // containing "Tenant"), so nothing could ever be authorized against it. Its
    // single usage — the "My Applications" navbar item — silently disappeared
    // for every non-admin user as a result.
    //
    // Do not re-add a member here without adding the matching action to the AVP
    // schema AND a policy that grants it: an enum entry alone authorizes nothing
    // and fails CLOSED and SILENTLY.

    ListOrganizations = 'ListOrganizations',
    GetOrganization = 'GetOrganization',
    CreateOrganization = 'CreateOrganization',
    UpdateOrganization = 'UpdateOrganization',
    DeleteOrganization = 'DeleteOrganization',


    ListManagedAccounts = 'ListManagedAccounts',
    GetManagedAccount = 'GetManagedAccount',
    CreateManagedAccount = 'CreateManagedAccount',
    UpdateManagedAccount = 'UpdateManagedAccount',
    DeleteManagedAccount = 'DeleteManagedAccount',

    ListUsers = 'ListUsers',
    GetUser = 'GetUser',
    CreateUser = 'CreateUser',
    UpdateUser = 'UpdateUser',
    DeleteUser = 'DeleteUser',
}


export const actions = Object.values(rbacActions);

export const actionConstants = actions.reduce((acc, action) => {
    acc[action.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? '_' : '') + match.toLowerCase())
              .toUpperCase()] = action;
    return acc;
}, {} as Record<string, string>);
